import { Component, computed, inject, input } from '@angular/core';
import { NgTemplateOutlet } from '@angular/common';
import type { TextField } from '@core/jss-proxy';
import { CoreJssProxyModule } from '@core/jss-proxy';
import { RichTextWrapperComponent } from '@legacy/common-ui-utility-components';
import { FieldService } from '@core/jss-utils';

@Component({
  selector: 'wl-content-single-column-text-section',
  standalone: true,
  imports: [CoreJssProxyModule, RichTextWrapperComponent, NgTemplateOutlet],
  templateUrl: './content-single-column-text-section.component.html',
  styleUrls: [
    './content-single-column-text-section.component.ed.scss',
    './content-single-column-text-section.component.essent.scss',
  ],
})
export class ContentSingleColumnTextSectionComponent {
  readonly aside = input<boolean>(false);
  readonly heading = input.required<TextField>();
  readonly richText = input.required<TextField>();

  readonly #fieldService = inject(FieldService);

  readonly showRichText = computed(() =>
    this.#fieldService.showTextField(this.richText())
  );
}
